import { Component, OnInit, Renderer2, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Align } from "@progress/kendo-angular-popup";
import { EIPAutoCompleteComponent } from "eipauto-complete";
import { CommonService } from "src/app/Service/Common.service";
import { NotificationService } from "src/app/Service/notification.service";
import { ProjectMasterService } from "src/app/Service/projectmaster/projectmaster.service";
import { IProjectMasterViewModel } from "src/app/ViewModel/ProjectMasterModel";
import { EditProjectComponent } from "../dialogs/project-dialog/edit-project.component";
import { EnableSimilarProject } from '../dialogs/Enable_Similar_Project/Enable_Similar_Project.component';
import { BusinessGroupModel } from 'src/app/ViewModel/BusinessGroupModel';
import { ProjectMemberLinkService } from 'src/app/Service/projectMemberLink/project-member-link.service';
import { RoleFeatureModel } from 'src/app/ViewModel/RoleFeatureModel';
import { MapRoleFeatureService } from 'src/app/Service/map-role-feature/map-role-feature.service';
import { IOrganizationViewModel } from 'src/app/ViewModel/OrganizationModel';
import { OrganizationService } from 'src/app/Service/organization/organization.service';
import * as moment from "moment";

@Component({
    selector: 'app-projects',
    templateUrl: './projects.component.html',
    styleUrls: ['./projects.component.css']
})
export class ProjectsComponent implements OnInit {
    public eipAnchorElementPopup: any;
    private eipAutoComplete!: EIPAutoCompleteComponent;
    private eipAutoCompleteDiv: any;
    public edrcAnchorElementPopup: any;
    private edrcAutoComplete!: EIPAutoCompleteComponent;
    private edrcAutoCompleteDiv: any;
    icList: RoleFeatureModel[] = [];
    businessGroups: any | IOrganizationViewModel[] = [];
    @ViewChild('eipAuotCompleteDiv') set eipAutoCompleteDivElement(contentDiv: any) {
        this.eipAutoCompleteDiv = contentDiv;
    }
    @ViewChild('eipAutoComplete') set eipAutoCompleteElement(content: EIPAutoCompleteComponent) {
        if (!!content) {
            this.eipAutoComplete = content;
        }
    }
    @ViewChild('edrcAutoCompleteDiv') set edrcAutoCompleteDivElement(contentDiv: any) {
        this.edrcAutoCompleteDiv = contentDiv;
    }
    @ViewChild('edrcAutoComplete') set edrcAutoCompleteElement(content: EIPAutoCompleteComponent) {
        if (!!content) {
            this.edrcAutoComplete = content;
        }
    }
    popupAlignRight: Align = { horizontal: 'right', vertical: 'top' };
    anchorAlignRight: Align = { horizontal: 'right', vertical: 'bottom' };
    IsShowEipList: boolean = false;
    IsShowEDRCList: boolean = false;
    enableFilter = false;
    enableFullscreen = false;
    public pageSize = [50, 100, 200, {
        text: 'All',
        value: 'all'
    }];
    jobList: any[] = [];
    edrcJobList: any[] = [];
    memberId!: number;
    /**Projects list */
    public projectList: IProjectMasterViewModel[] = [];
    constructor(private _dialog: MatDialog, private _notificationService: NotificationService, public mapRoleFeatureService: MapRoleFeatureService, public projectMemberLinkService: ProjectMemberLinkService,
        private _commonService: CommonService, private _projectService: ProjectMasterService, private _renderer2: Renderer2, private _orgService: OrganizationService) {

    }
    ngOnInit() {
        this.memberId = this._commonService.getLoggedInUserId();
        this.getProjectsList();
        this.getIcList();
        this.getOrganizationList();
    }

    /**
    * Get projects list
    */
    getProjectsList() {
        this._projectService.getProjects(undefined || null, this.memberId).subscribe((data: IProjectMasterViewModel[]) => {
            this.projectList = data;
        });
    }
    /**
  * Get organization list
  */
    async getOrganizationList() {
        this.businessGroups = await this._orgService.getOrganizationList().toPromise();
    }
    async getIcList() {
        this.icList = await this.mapRoleFeatureService.getCommonDedAgainstDe(null, "IC").toPromise();
    }

    EnableSimilarProject(project: IProjectMasterViewModel) {
        if (project.project_Id)
            this.projectMemberLinkService.getProjectBusinessGroup(project.project_Id).subscribe((response: BusinessGroupModel[]) => {
                response = response.filter(each => each.is_Active);
                if (!response || response.length == 0) {
                    this._notificationService.showToast("business group not available against" + project.project_Description, "Warning");
                }
                else {
                    const dialogRef = this._dialog.open(EnableSimilarProject, {
                        panelClass: 'mat-dialog-secondary',
                        width: '95%',
                        minWidth: '95vw',
                        data: { project: project, IprojectList: this.projectList, isImport: false }
                    });
                    dialogRef.afterClosed().subscribe((res: any) => {
                        if (res) {
                            let resproject: IProjectMasterViewModel = res.project;
                            if (res.response && res.response.successCode == 200) {

                                this._notificationService.showToast(res.response.successMessage, "Success");
                            }
                            else if (res.response.successCode == 205) {
                                this._notificationService.showToast(res.response.successMessage, "Warning");
                            }
                        }
                    }, err => { });
                }
            });

    }
    addEditProject(project?: null | IProjectMasterViewModel) {
        this.IsShowEDRCList = false;
        this.IsShowEipList = false;
        if (project === undefined)
            project = null;
        const dialogRef = this._dialog.open(EditProjectComponent, {
            panelClass: 'mat-dialog-secondary',
            width: '95%',
            minWidth: '95vw',
            data: { project: project, isImport: false, icList: this.icList, businessGroups: this.businessGroups }
        });
        dialogRef.afterClosed().subscribe((res: any) => {
            if (res) {
                let resproject: IProjectMasterViewModel = res.project;
                if (res.response && res.response.successCode == 200 && resproject) {
                    this.getProjectsList();
                    this._notificationService.showToast(res.response.successMessage, "Success");
                }
                else if (res.response.successCode == 205) {
                    this._notificationService.showToast(res.response.successMessage, "Warning");
                }
            }
        }, err => { });
    }

    copyProjectAttributes(source: IProjectMasterViewModel, destination: IProjectMasterViewModel) {
        destination.project_Description = source.project_Description;
        destination.project_Short_Description = source.project_Short_Description;
        destination.is_Active = source.is_Active;
        destination.project_Type = source.project_Type;
        destination.user_Id = source.user_Id;
        destination.is_Cloud_Storage = source.is_Cloud_Storage;
        destination.start_Date = source.start_Date;
        destination.end_Date = source.end_Date;
        destination.project_URL = source.project_URL;
        destination.project_Logo_URL = source.project_Logo_URL;
        destination.job_Code = source.job_Code;
        destination.project_Code = source.project_Code;
    }

    /**
   * Toggle filter
   */
    toggleFilter() {
        this.enableFilter = !this.enableFilter;
    }
    /**
     * Toggle full screen
     */
    toggleFullscreen() {
        this.enableFullscreen = !this.enableFullscreen;
    }
    showEipList(event: any) {
        this.IsShowEDRCList = false;
        if (this.jobList.length == 0) {
            this._projectService.getEipjobList({ doptCode: "V", dtCode: 30013, userId: 1120704, searchText: "" }).subscribe(res => {
                this.jobList = res;
                this.IsShowEipList = !this.IsShowEipList;
                this.eipAnchorElementPopup = event.target;
            });
        }
        else {
            this.IsShowEipList = !this.IsShowEipList;
            this.eipAnchorElementPopup = event.target;
        }
    }

    showEDRCList(event: any) {
        this.IsShowEipList = false;
        if (this.edrcJobList.length == 0) {
            this._projectService.getEDRCjobList({ search_Text: "", group_Code: "" }).subscribe(res => {
                this.edrcJobList = res;
                this.IsShowEDRCList = !this.IsShowEDRCList;
                this.edrcAnchorElementPopup = event.target;
            });
        }
        else {
            this.IsShowEDRCList = !this.IsShowEDRCList;
            this.edrcAnchorElementPopup = event.target;
        }
    }

    setSelectedEDRCJob(selectedJob: any) {
        if (selectedJob.value != -2) {
            this.IsShowEDRCList = false;
            let project: any | IProjectMasterViewModel = {
                project_Code: selectedJob.additionalValues.additionalValues.proj_Code,
                project_Short_Description: selectedJob.additionalValues.additionalValues.proj_Code,
                project_Description: selectedJob.additionalValues.additionalValues.proj_Description,
                job_Code: selectedJob.additionalValues.additionalValues.proj_Code,
                project_Type: 'EDRC',
                is_Active: true,
                user_Id: this.memberId,
                start_Date: selectedJob.additionalValues.additionalValues.proj_Start_Date,
                end_Date: selectedJob.additionalValues.additionalValues.proj_End_Date,
                iC_Id: selectedJob.additionalValues.additionalValues.iC_Id,
                ic_Description: ''
            }
            const dialogRef = this._dialog.open(EditProjectComponent, {
                panelClass: 'mat-dialog-secondary',
                width: '95%',
                minWidth: '95vw',
                data: { project: project, isImport: true, icList: this.icList }
            });
            dialogRef.afterClosed().subscribe((res: any) => {
                if (res) {
                    let resproject: IProjectMasterViewModel = res.project;
                    if (res.response && res.response.successCode == 200 && resproject) {
                        this.getProjectsList();
                        this._notificationService.showToast(res.response.successMessage, "Success");
                    }
                    else if (res.response.successCode == 205) {
                        this._notificationService.showToast(res.response.successMessage, "Warning");
                    }
                }
            }, err => { });
        }
    }



    setSelectedJob(selectedJob: any) {
        if (selectedJob.value != -2) {
            this.IsShowEipList = false;
            let project: any | IProjectMasterViewModel = {
                project_Code: selectedJob.value,
                project_Short_Description: selectedJob.value,
                project_Description: selectedJob.desc,
                job_Code: selectedJob.value,
                project_Type: 'EIP',
                is_Active: true,
                user_Id: this.memberId,
                iC_Id: selectedJob.iC_Id,
                ic_Description: ''
            }
            const dialogRef = this._dialog.open(EditProjectComponent, {
                panelClass: 'mat-dialog-secondary',
                width: '95%',
                minWidth: '95vw',
                data: { project: project, isImport: true, icList: this.icList }
            });
            dialogRef.afterClosed().subscribe((res: any) => {
                if (res) {
                    let resproject: IProjectMasterViewModel = res.project;
                    if (res.response && res.response.successCode == 200 && resproject) {
                        this.getProjectsList();
                        this._notificationService.showToast(res.response.successMessage, "Success");
                    }
                    else if (res.response.successCode == 205) {
                        this._notificationService.showToast(res.response.successMessage, "Warning");
                    }
                }
            }, err => { });
        }
    }
}